import { useEffect, useState } from "react";

const ProgressCircle = ({exercise, color, children}) => {
    const [clickColor, setClickColor] = useState(0);
    const [click2Color, setClick2Color] = useState(0);
    const [speakColor, setSpeakColor] = useState(0);
    const [writeColor, setWriteColor] = useState(0);

    const avg = (array) => {
        if ((typeof array[0]) === "number") {
            array = array.map(x => (x - 1) / 2.0);
        }
        return array.reduce((x, y) => x + y, 0) / array.length;
    }

    const fractionToColor = (x) => {
        const red = Math.round(255 * (1 - x));
        const green = Math.round(255 * x);
        return `rgb(${red}, ${green}, 0)`;
    }

    useEffect(() => {
        const token = localStorage.getItem("token");
        fetch(`${process.env.REACT_APP_USER_API_URL}/stats/results/${exercise}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        }).then(resp => resp.json()).then(json => {
            if (json.gray) {
                setClickColor("gainsboro");
                setClick2Color("gainsboro");
                setSpeakColor("gainsboro");
                setWriteColor("gainsboro");
            } else {
                setClickColor(fractionToColor(avg(json.ListenAndClick)));
                setClick2Color(fractionToColor(avg(json.ListenAndClickII)));
                setSpeakColor(fractionToColor(avg(json.ListenAndSpeak)));
                setWriteColor(fractionToColor(avg(json.ListenAndWrite)));
            }
        });
    }, []);

    return <div className="relative flex justify-center items-center w-16 h-16">
        <div
            className="absolute inset-0 rounded-full"
            style={{
                backgroundColor: color
            }}
        />
        <div className="absolute flex justify-center items-center w-full h-full">
            <div
                className="rounded-full"
                style={{
                    width: "90%",
                    height: "90%",
                    background: `conic-gradient(
                        ${clickColor} 0% 25%,
                        ${click2Color} 25% 50%,
                        ${speakColor} 50% 75%,
                        ${writeColor} 75% 100%
                    )`,
                }}
            />
        </div>
        <div
            className="absolute flex justify-center items-center rounded-full text-center"
            style={{
                width: "70%",
                height: "70%",
                backgroundColor: color
            }}
        >
            {children}
      </div>
    </div>
}

export default ProgressCircle;